import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'shared-full-screen',
  templateUrl: './full-screen.component.html',
  styleUrls: ['./full-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SharedFullScreenComponent {
  readonly withBanner = input<boolean>(false);
}
